import { Component, inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Cls_MobiDynamicDialog } from "../models";

@Component({
  selector: "mobi-office-lib-dynamic-dialog",
  templateUrl: "./dynamic-dialog.component.html",
  styleUrls: ["./dynamic-dialog.component.scss"],
  standalone: false,
})
export class DynamicDialogComponent {
  private dialogRef = inject(MatDialogRef<DynamicDialogComponent>);
  public data: Cls_MobiDynamicDialog = inject(MAT_DIALOG_DATA);

  constructor() {}

  closeDialog() {
    this.dialogRef.close(true);
  }
}
